import React, { useState } from "react";
import axios from "axios";
import { ResetPassword } from "./ResetPassword";
import "../../styles/HomeStyling/ForgotPassword.css";

export const ForgotPassword = ({ onBack }) => {
  const Back = `${process.env.PUBLIC_URL}/assets/logos/back.svg`;

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [showReset, setShowReset] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/forgot_password`,
        { email }
      );
      setMessage(response.data.message);
      if (response.data.success) {
        setShowReset(true);
      }
    } catch (err) {
      setMessage(
        err.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {showReset ? (
        <div className="forgot-password-container">
          <ResetPassword email={email} onBack={onBack} />
        </div>
      ) : (
        <div className="forgot-form-container">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              width: "fit-content",
              borderRadius: "50px",
              backgroundColor: "#eaeaea",
              padding: "10px",
            }}
          >
            <img src={Back} alt="Back to Login" onClick={onBack} />
          </div>
          <h2 className="login-title">Forgot Password</h2>
          {message && <p className="forgot-password-message">{message}</p>}
          <form
            className="login-form-group forgot-container"
            onSubmit={handleForgotPassword}
          >
            <label className="login-label">Email</label>
            <input
              id="forgot-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="login-input"
              required
            />
          </form>
          <div className="action-buttons">
            <button
              type="submit"
              className="submit-btn"
              disabled={loading}
              onClick={handleForgotPassword}
            >
              {loading ? "Sending..." : "Send OTP"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};
